import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Terminos = () => {
  const { t } = useTranslation();

  return (
    <div style={{ background: '#080810', color: '#F5F5F0', fontFamily: "'Inter', sans-serif", lineHeight: '1.6', padding: '40px 20px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', background: '#14141f', borderRadius: '24px', padding: '40px', border: '1px solid rgba(255,255,255,0.08)' }}>
        <h1 style={{ fontFamily: "'Oswald', sans-serif", fontSize: '28px', letterSpacing: '2px', marginBottom: '8px' }}>
          PITAZO <span style={{ color: '#F0B429' }}>MUNDIAL</span>
        </h1>
        <p style={{ marginTop: '8px', color: '#aaa' }}>{t('terms_title')}</p>
        <p style={{ color: '#aaa', marginBottom: '12px' }}><strong>{t('terms_last_update')}:</strong> abril 2026</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s1_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s1_p')}</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s2_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s2_p')}</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s3_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s3_p')}</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s4_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s4_p')}</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s5_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s5_p')}</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s6_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s6_p')}</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s7_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s7_p')}</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s8_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s8_p')}</p>

        <h2 style={{ color: '#F0B429', fontSize: '18px', margin: '24px 0 12px' }}>{t('terms_s9_title')}</h2>
        <p style={{ color: '#aaa', marginBottom: '12px' }}>{t('terms_s9_p')}</p>

        <hr style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0' }} />
        <Link to="/" style={{ display: 'inline-block', marginTop: '32px', color: '#F0B429', textDecoration: 'none' }}>
          ← {t('back_to_home')}
        </Link>
      </div>
    </div>
  );
};

export default Terminos;